export default "__VITE_ASSET__AE_IxoIB__"